'use client'

import { Loading } from '@/common/components/Loading'

const Page: React.FC = () => {
  return <Loading />
}

export default Page
